import React, { FunctionComponent } from "react";

export const Spinner: FunctionComponent = () => (
  <div className="text-center mt-5">
    <div className="spinner-border" role="status">
      <span className="visually-hidden">Loading...</span>
    </div>
  </div>
);
